import { Map } from 'immutable'

/**
 * @param {ReduxState} state redux state
 * @returns {Map}
 */
export function selectOracle (state) {
  return state.oracle || Map()
}

/**
 * @param {ReduxState} state redux state
 * @returns {Map}
 */
export function selectOracleAccess (state) {
  return selectOracle(state).get('access', Map())
}

/**
 * @param {ReduxState} state redux state
 * @returns {Boolean}
 */
export function selectHasVoiceAccess (state) {
  const access = selectOracleAccess(state)
  return access.get('aiSpeech', false)
}

/**
 * @param {ReduxState} state redux state
 * @returns {Boolean}
 */
export function selectHasUnlimitedChat (state) {
  const access = selectOracleAccess(state)
  return access.get('aiTextUnlimited', false)
}

/**
 * @param {ReduxState} state redux state
 * @returns {Boolean}
 */
export function selectOracleAccessProcessing (state) {
  return selectOracle(state).get('accessProcessing', false)
}
